import { ApiConstant, PathConstant, SystemConstant } from "const";

const vi = {
  login: {
    // TEXTS
    TXT_LOGIN: "Đăng nhập với quyền quản trị viên",
    TXT_CHANGE_INFO: "Thay đổi thông tin",
    TXT_ADD_AVATAR: "Thêm logo của công ty",

    // LABELS
    L_USERNAME: "Tài khoản",
    L_PASSWORD: "Mật khẩu",
    L_REMEMBER_ME: "Lưu đăng nhập",
    L_LOGIN_BUTTON: "Đăng nhập",
    L_NEW_PASSWORD: "Nhập mật khẩu của bạn",
    L_NEW_PASSWORD_CONFIRMATION: "Xác nhận mật khẩu",
    L_CONTINUE_BUTTON: "Tiếp tục",

    // PLACEHOLDERS
    P_USERNAME: "Nhập tài khoản của bạn",
    P_PASSWORD: "Nhập mật khẩu của bạn",
    P_NEW_PASSWORD: "Nhập mật khẩu của bạn",

    // ERROR OBJECT
    ERR_OBJECT: {
      [ApiConstant.STT_UNAUTHORIZED]: "Sai tài khoản hoặc mật khẩu. Vui lòng thử lại!",
      [ApiConstant.STT_NOT_FOUND]: "Sai tài khoản hoặc mật khẩu. Vui lòng thử lại!",
      passwordConfirmationNotMatch: "Trường xác nhận mật khẩu và mật khẩu không khớp",
      imageNotValid: "Vui lòng chọn ảnh định dạng PNG hoặc JPG",
      somethingWrong: "Đã có lỗi xảy ra, vui lòng thử lại sau",
    },
  },

  common: {
    // OBJECTS
    OBJ_ROUTER_TITLE: {
      [PathConstant.LOGIN]: "Đăng nhập với quyền quản trị viên",
      [PathConstant.FIRST_LOGIN]: "Thay đổi thông tin",
      [PathConstant.COMPANY_MANAGEMENT]: "Quản lý tổ chức",
      [PathConstant.USER_MANAGEMENT]: "Quản lý người dùng",
      [PathConstant.LICENSE]: "Bản quyền",
      [PathConstant.SETTINGS]: "Cài đặt",
      [PathConstant.CONFERENCE_MANAGEMENT]: "Quản lý ứng dụng",
      [PathConstant.SYSTEM_TRACKING]: "Theo dõi hệ thống",
      [PathConstant.BRANCH_MANAGEMENT]: "Quản lý branch server",
      [PathConstant.VERIFY_SMART_OTP]: "Xác thực bằng SMART OTP",
      [PathConstant.POSITION_MANAGEMENT]: "Quản lý vị trí",
      [PathConstant.MEDIA_MANAGEMENT]: "Quản lý tin truyền thông",
      [PathConstant.STATISTIC]: "Thống kê",
      [PathConstant.CHANNEL_MANAGEMENT]: "Quản lý kênh",
      [PathConstant.DEPARTMENT_MANAGEMENT]: "Quản lý phòng ban",
      [PathConstant.DEVICE_MANAGEMENT]: "Quản lý thiết bị",
    },

    OBJ_SIDEBAR_TITLE: {
      companyManagement: "Quản lý tổ chức",
      companyProfile: "Hồ sơ tổ chức",
      departmentManagement: "Quản lý phòng ban",
      userManagement: "Quản lý người dùng",
      license: "Bản quyền",
      settings: "Cài đặt",
      conferenceManagement: "Quản lý ứng dụng",
      logout: "Đăng xuất",
      systemTracking: "Theo dõi hệ thống",
      branchManagement: "Quản lý Branch Server",
      serverMonitoring: "Giám sát máy chủ",
      positionManagement: "Quản lý vị trí",
      mediaManagement: "Quản lý tin truyền thông",
      statistic: "Thống kê",
      channelManagement: "Quản lý kênh & nhóm",
      deviceManagement: "Quản lý thiết bị",
    },

    OBJ_ERROR_MSG: {
      wrongPassword: "Mật khẩu không chính xác! Xin vui lòng thử lại",
      passwordConfirmationNotMatch: "Trường xác nhận mật khẩu và mật khẩu mới không khớp",
    },

    OBJ_USER_DETAIL: {
      userName: "Tên người dùng",
      fullName: "Họ và tên",
      phone: "Số điện thoại",
      email: "Email",
      birthday: "Ngày sinh",
      activeStatus: "Trạng thái hoạt động",
      joinStatus: "Trạng thái tham gia",
      unit: "Đơn vị",
      department: "Phòng ban",
    },

    OBJ_BRANCH_ERROR: {
      updateTime: "Thời gian cập nhật",
      fromDate: "Từ ngày",
      toDate: "Đến ngày",
      search: "Tra cứu",
      branchServer: "Branch Server",
    },

    OBJ_TABLE_ERROR: {
      number: "STT",
      errorFeature: "Chức năng gặp vấn đề",
      errorComponent: "Thành phần gặp vấn đề",
      time: "Thời gian",
      description: "Mô tả",
      rowsPerPage: "Số bản ghi hiển thị",
    },

    OBJ_TABLE_USER_ACTIVITIES: {
      number: "STT",
      user: "ID Người dùng",
      action: "Hành động",
      time: "Thời gian",
      ipAddress: "Địa chỉ IP",
      rowsPerPage: "Số bản ghi hiển thị",
    },

    OBJ_TABLE_BRANCH: {
      number: "STT",
      avatar: "Ảnh đại diện",
      branchName: "Tên Branch Server",
      package: "Package",
      packageId: "Package ID",
      license: "Số Giấy Phép",
      existAccount: "Số tài khoản đăng ký",
      status: "Trạng thái",
      action: "Hành động",
    },

    OBJ_CONFIRM_RESET: {
      title: "Đặt lại mật khẩu",
      content: "Bạn muốn đặt lại mật khẩu cho người dùng đã chọn không ?",
      acceptButton: "Đồng ý",
      cancelButton: "Hủy bỏ",
    },

    OBJ_BRANCH_ERROR_TYPE: {
      sendMessage: "Gửi tin nhắn",
      audioCall: "Gọi đơn",
      videoCall: "Gọi video đơn",
      audioGroupCall: "Gọi nhóm",
      videoGroupCall: "Gọi video nhóm",
      updateProfile: "Cập nhật hồ sơ",
    },

    OBJ_RANDOM_ADMIN_PASSWORD: {
      title: "Mật khẩu mới",
      content: "Mật khẩu mới của quản trị viên là: {{password}}",
      close: "Đóng",
      copy: "Sao chép mật khẩu",
    },

    OBJ_USER_ACTIVITIES: {
      [SystemConstant.LOGGER_ACTION_TYPES.LOGIN]: "Đăng nhập",
      [SystemConstant.LOGGER_ACTION_TYPES.LOGOUT]: "Đăng xuất",
      [SystemConstant.LOGGER_ACTION_TYPES.UPDATE_BRANCH_INFORMATION]: "Cập nhật thông tin branch",
      [SystemConstant.LOGGER_ACTION_TYPES.ADD_NEW_USERS]: "Thêm mới người dùng vào branch",
      [SystemConstant.LOGGER_ACTION_TYPES.ACTIVE_USER]: "Kích hoạt người dùng",
      [SystemConstant.LOGGER_ACTION_TYPES.BLOCK_USER]: "Vô hiệu hóa người dùng",
      [SystemConstant.LOGGER_ACTION_TYPES.UPDATE_USER_INFORMATION]: "Cập nhật thông tin người dùng",
      [SystemConstant.LOGGER_ACTION_TYPES.RESET_USER_PASSWORD]: "Đặt lại mật khẩu người dùng",
      [SystemConstant.LOGGER_ACTION_TYPES.CHANGE_PASSWORD]: "Đổi mật khẩu",
      [SystemConstant.LOGGER_ACTION_TYPES.UPDATE_BRANCH_CONFIGS]: "Cập nhật cấu hình branch",
      [SystemConstant.LOGGER_ACTION_TYPES.IMPORT_NEW_USERS_FROM_EXCEL]: "Thêm mới người dùng bằng file Excel",
      [SystemConstant.LOGGER_ACTION_TYPES.ADD_BRANCH]: "Thêm branch server",
      [SystemConstant.LOGGER_ACTION_TYPES.DELETE_BRANCH]: "Xóa branch serve",
      [SystemConstant.LOGGER_ACTION_TYPES.ACTIVATE_BRANCH]: "Kích hoạt branch",
      [SystemConstant.LOGGER_ACTION_TYPES.DEACTIVATE_BRANCH]: "Vô hiệu hóa branch",
      [SystemConstant.LOGGER_ACTION_TYPES.CREATE_UNIT]: "Thêm đơn vị",
      [SystemConstant.LOGGER_ACTION_TYPES.EDIT_UNIT]: "Cập nhật đơn vị",
      [SystemConstant.LOGGER_ACTION_TYPES.DELETE_UNIT]: "Xóa đơn vị",
      [SystemConstant.LOGGER_ACTION_TYPES.CREATE_DEPARTMENT]: "Thêm phòng ban",
      [SystemConstant.LOGGER_ACTION_TYPES.EDIT_DEPARTMENT]: "Cập nhật phòng ban",
      [SystemConstant.LOGGER_ACTION_TYPES.DELETE_DEPARTMENT]: "Xóa phòng ban",
      [SystemConstant.LOGGER_ACTION_TYPES.ADD_DEPARTMENT_USERS]: "Thêm thành viên phòng ban",
      [SystemConstant.LOGGER_ACTION_TYPES.REMOVE_DEPARTMENT_USERS]: "Xóa thành viên phòng ban",
      [SystemConstant.LOGGER_ACTION_TYPES.CREATE_UNIT_CHANNEL]: "Tạo kênh đơn vị",
      [SystemConstant.LOGGER_ACTION_TYPES.CREATE_DEPARTMENT_CHANNEL]: "Tạo kênh phòng ban",
      [SystemConstant.LOGGER_ACTION_TYPES.CREATE_POSITION]: "Thêm vị trí",
      [SystemConstant.LOGGER_ACTION_TYPES.EDIT_POSITION]: "Cập nhật vị trí",
      [SystemConstant.LOGGER_ACTION_TYPES.DELETE_POSITION]: "Xóa vị trí",
    },

    OBJ_USER_FILTER_STATUS: {
      inactive: "Vô hiệu hóa",
      active: "Đã tham gia",
      all: "Tất cả",
      pending: "Đang chờ",
    },

    OBJ_UNIT_LIST_TABLE: {
      name: "Tên đơn vị/phòng ban",
      departmentNumber: "Số phòng ban",
      employeeNumber: "Số nhân sự",
    },

    OBJ_UNIT_DETAIL: {
      name: "Tên đơn vị",
      branch: "Trực thuộc",
    },

    OBJ_UNIT_ERROR: {
      [SystemConstant.UNIT_ERROR.MISSING_PARAMETERS]: "Dữ liệu truyền lên thiếu",
      [SystemConstant.UNIT_ERROR.IN_WRONG_FORMAT]: "Tên đơn vị không đúng định dạng",
      [SystemConstant.UNIT_ERROR.DUPLICATED]: "Đơn vị đã tồn tại",
      [SystemConstant.UNIT_ERROR.CONTAIN_DEPARTMENTS]: "Không thể xóa đơn vị này, đơn vị đang có phòng ban trực thuộc",
    },

    OBJ_DEPARTMENT_DETAIL: {
      name: "Tên phòng ban",
      unit: "Trực thuộc đơn vị",
    },

    OBJ_DEPARTMENT_ERROR: {
      [SystemConstant.DEPARTMENT_ERROR.MISSING_PARAMETERS]: "Dữ liệu truyền lên thiếu",
      [SystemConstant.DEPARTMENT_ERROR.IN_WRONG_FORMAT]: "Tên phòng ban không đúng định dạng",
      [SystemConstant.DEPARTMENT_ERROR.DUPLICATED]: "Phòng ban đã tồn tại",
      [SystemConstant.DEPARTMENT_ERROR.CHANNEL_DUPLICATED]: "Kênh của phòng ban này đã có",
      [SystemConstant.DEPARTMENT_ERROR.CHANNEL_MISSING_PARAMETERS]: "DỮ liệu tạo kênh thiếu",
    },

    OBJ_POSITION_ERROR: {
      [SystemConstant.DEPARTMENT_ERROR.MISSING_PARAMETERS]: "Dữ liệu truyền lên thiếu",
      [SystemConstant.DEPARTMENT_ERROR.IN_WRONG_FORMAT]: "Tên vị trí không đúng định dạng",
      [SystemConstant.DEPARTMENT_ERROR.DUPLICATED]: "Tên vị trí đã tồn tại",
    },

    OBJ_CONFERENCE_ERROR: {
      [SystemConstant.CONFERENCE_ERROR.MISSING_PARAMETERS]: "Dữ liệu truyền lên thiếu",
      [SystemConstant.CONFERENCE_ERROR.IN_WRONG_FORMAT]: "Tên ứng dụng không đúng định dạng",
      [SystemConstant.CONFERENCE_ERROR.DUPLICATED]: "Tên ứng dụng đã tồn tại",
    },

    OBJ_ROLE_ACCOUNT_ERROR: {
      [SystemConstant.ROLE_ACCOUNT_ERROR.MISSING_PARAMETERS]: "Dữ liệu truyền lên thiếu",
      [SystemConstant.ROLE_ACCOUNT_ERROR.IN_WRONG_FORMAT]: "Dữ liệu không đúng định dạng",
      [SystemConstant.ROLE_ACCOUNT_ERROR.DUPLICATED]: "Dữ liệu đã tồn tại",
    },

    OBJ_CHANNEL_DIALOG: {
      unitTitle: "Tạo kênh đơn vị",
      departmentTitle: "Tạo kênh phòng DA",
      channelName: "Tên kênh",
      channelMode: "Chế độ kênh",
      channelManager: "Chọn quản lý kênh",
      unitConfirm: "Bạn chắc chắn thực hiện tạo kênh cho đơn vị này",
      departmentConfirm: "Bạn chắc chắn thực hiện tạo kênh cho phòng ban này?",
      noUser: "Không có người dùng",
    },

    OBJ_CREATE_CHANNEL_DIALOG: {
      title: "Tạo kênh mới",
      titleGroup: "Tạo nhóm mới",
      channelName: "Tên kênh",
      groupName: "Tên nhóm",
      channelNamePlaceholder: "Nhập tên kênh",
      groupNamePlaceholder: "Nhập tên nhóm",
      channelMode: "Chế độ",
      channelAdmin: "Quản trị kênh",
      groupAdmin: "Quản trị nhóm",
      selectAdmin: "Chọn quản trị viên",
      selectMembers: "Chọn thành viên",
      selectedMembers: "Thành viên đã chọn",
      searchPlaceholder: "Tìm kiếm theo tên, số điện thoại",
      selectedCount: "Đã chọn",
      confirm: "Bạn có chắc chắn muốn tạo?",
      nameRequired: "Vui lòng nhập tên",
      memberRequired: "Vui lòng chọn ít nhất 1 thành viên",
      adminRequired: "Vui lòng chọn quản trị viên",
      remove: "Xóa",
      submitChannel: "Tạo kênh",
      submitGroup: "Tạo nhóm",
    },

    OBJ_CHANNEL_LIST_TABLE: {
      channelName: "Tên",
      memberCount: "Số lượng thành viên",
      channelType: "Loại kênh",
      action: "Thao tác",
    },

    OBJ_UPDATE_CHANNEL_DIALOG: {
      title: "Chỉnh sửa",
      totalMembers: "Tổng số thành viên",
      searchPlaceholder: "Tìm kiếm người dùng theo tên, số điện thoại",
      searchLabel: "Quản trị viên (*)",
      userListTitle: "Danh sách người dùng",
      addMember: "Thêm thành viên",
      colFullName: "Họ và tên",
      colUnit: "Đơn vị",
      colDepartment: "Phòng ban",
      colPosition: "Vị trí",
      colRole: "Vai trò",
      colAction: "Thao tác",
      roleAdmin: "Quản trị viên",
      roleMember: "Thành viên",
    },

    OBJ_ADD_CHANNEL_MEMBER_DIALOG: {
      title: "Thêm người dùng vào kênh",
      searchLabel: "Quản trị viên (*)",
      searchPlaceholder: "Tìm kiếm người dùng theo tên, số điện thoại",
      selectedCount: "Số người dùng đã chọn",
      colFullName: "Họ và tên",
      colUnit: "Đơn vị",
      colDepartment: "Phòng ban",
      colPosition: "Vị trí",
      addMember: "THÊM THÀNH VIÊN",
      cancel: "HỦY",
    },

    // LABELS
    L_NEED_HELP_BUTTON: "Trợ giúp",
    L_COMPANY_NAME: "Tên tổ chức",
    L_COMPANY_AVATAR: "Ảnh đại diện",
    L_CHANGE_COMPANY_AVATAR_BUTTON: "Thay đổi",
    L_CONFIRM_BUTTON: "Xác nhận",
    L_DISCARD_BUTTON: "Huỷ",
    L_DELETE_USER_BUTTON: "Xoá",
    L_ADD_NEW_USER_BUTTON: "Thêm mới",
    L_JOINED_STATUS: "Đã tham gia",
    L_PENDING_STATUS: "Đang chờ",
    L_REFUSED_STATUS: "Đã từ chối",
    L_ACTIVE_FUNCTION: "Trạng thái hoạt động",
    L_FN_DISABLED: "Vô hiệu hóa",
    L_FN_LOGGED_IN: "Đã đăng nhập",
    L_FN_NOT_LOGGED_IN: "Chưa đăng nhập",
    L_FN_SUSPENDED: "Ngưng hoạt động",
    L_REMOVE_BUTTON: "Vô hiệu hóa",
    L_CANCEL_BUTTON: "Huỷ bỏ",
    L_ADD_BUTTON: "Thêm",
    L_ACTIVE: "Đã kích hoạt",
    L_ACTIVATION_STATE: "Trạng thái kích hoạt",
    L_EXPIRED: "Đã hết hạn",
    L_UPGRADE_LICENSE: "Nâng cấp giấy phép của bạn",
    L_PASSWORD_LAST_UPDATE: "Cập nhật lần cuối: {{time}}",
    L_OLD_PASSWORD: "Nhập mật khẩu cũ của bạn",
    L_UPDATE_PASSWORD_BUTTON: "Cập nhật mật khẩu",
    L_LANGUAGE: "Ngôn ngữ",
    L_VIETNAMESE_LANGUAGE: "Tiếng Việt",
    L_ENGLISH_LANGUAGE: "Tiếng Anh",
    L_SAVE_BUTTON: "Lưu thay đổi",
    L_PUBLIC_MODE: "Công khai",
    L_PRIVATE_MODE: "Riêng tư",
    L_PASSWORD_MODE: "Mật khẩu",
    L_OTP_MODE: "Mã OTP",
    L_ACTIVE_USER: "Hoạt động",
    L_INACTIVE_USER: "Ngưng hoạt động",
    L_BRANCH_LIST: "Danh sách Branch Server",
    L_OK: "OK",
    L_CREATE: "Tạo mới",
    L_SWITCH_BRANCH: "Chuyển branch",
    L_ACTIVE_ACTION: "Kích hoạt",
    L_INACTIVE_ACTION: "Vô hiệu hóa",
    L_UPDATE: "Cập nhật",
    L_AGREE: "Có",
    L_SAVE_INFO: "Lưu thông tin",
    L_CANCEL_ADD_BRANCH: "Hủy",
    L_STATUS: "Trạng thái",
    L_ACCEPT: "Đồng ý",
    L_DOWNLOAD_FILE: "Tải file",
    L_ADD_UNIT_BUTTON: "Thêm đơn vị",
    L_GRANT_ADMIN_PERMISSION: "Cấp quyền",
    L_REMOVE_ADMIN_PERMISSION: "Xóa quyền",
    L_DELETE: "Xóa",
    L_CANCEL: "Hủy",
    L_ALL: "Tất cả",
    L_CLOSE: "Đóng",
    L_SELECT_UNIT: "Đơn vị",
    L_GENERATE_PASSWORD: "Tạo mật khẩu mới",
    L_UNDERSTOOD: "Đã hiểu",

    // PLACEHOLDERS
    P_COMPANY_NAME: "Nhập tên tổ chức của bạn",
    P_ADD_NEW_USER: "Tìm kiếm theo tên hoặc số điện thoại",
    P_OLD_PASSWORD: "Nhập mật khẩu cũ của bạn",
    P_SEARCH: "Tìm kiếm",
    P_SEARCH_UNIT: "Tìm kiếm theo tên đơn vị",
    P_SEARCH_POSITION: "Tìm kiếm theo tên vị trí",
    P_SEARCH_APP: "Tìm kiếm theo tên ứng dụng",
    P_POSITION_NAME: "Nhập tên vị trí",
    P_SEARCH_USER_BY_NAME_PHONE_EMAIL: "Tìm kiếm theo tên, sđt, email",
    P_SEARCH_USER_BY_NAME_EMAIL: "Tìm kiếm theo tên, email",
    P_SEARCH_USER_BY_NAME_PHONE: "Tìm kiếm theo tên, sđt",
    P_ADD_NEW_ADMIN: "Tìm kiếm người dùng theo tên, số điện thoại",

    // TEXTS
    TXT_APP_COPYRIGHT: "Bản quyền thuộc về © bGlobal Jsc. Đã đăng ký bản quyền",
    TXT_COMPANY_PROFILE: "Hồ sơ tổ chức",
    TXT_INVITE_AGAIN: "Mời lại",
    TXT_INVITED: "Đã mời",
    TXT_CONFIRM_REMOVE_USER_HEADING: "Xác nhận vô hiệu hóa người dùng",
    TXT_ADD_NEW_USER: "Thêm người dùng mới",
    TXT_EXPORT_USER_LIST: "Xuất danh sách",
    TXT_ENTER_NEW_PASSWORD: "Nhập mật khẩu mới",
    TXT_SELECTED_USER: "Người dùng đã chọn",
    TXT_CONTACT_FOUND: "Người dùng được tìm thấy",
    TXT_NOT_FOUND: "Không có dữ liệu",
    TXT_LOADING: "Đang tải dữ liệu",
    TXT_SERVER_EXPIRED: "Máy chủ đã hết hạn",
    TXT_SERVER_ACTIVE: "Máy chủ này được kích hoạt với giấy phép {{name}} cho đến ngày",
    TXT_UPGRADE_LICENSE_PHONE_NUM: "Bạn muốn nâng cấp giấy phép sử dụng? Hãy gọi vào số",
    TXT_UPDATE_PASSWORD_SUCCESS: "Đổi mật khẩu thành công",
    TXT_CHANGE_PASSWORD: "Đổi mật khẩu",
    TXT_CHANGE_PASSWORD_TITLE: "Khi hoàn thành đổi mật khẩu, tài khoản sẽ đăng xuất khỏi thiết bị",
    TXT_INFORMATION: "Chi tiết",
    TXT_EDIT_INFO: "Chỉnh sửa",
    TXT_RESET_PASSWORD: "Đặt lại mật khẩu",
    TXT_DETAILS_INFO: "Thông tin người dùng",
    TXT_EDIT_USER_INFO: "Chỉnh sửa thông tin",
    TXT_PROFILE_INFO: "Thông tin công việc",
    TXT_USER_ACTIVITIES: "Hoạt động kênh & nhóm",
    TXT_CHANNELS_AND_GROUPS: "Kênh & nhóm tham gia",
    TXT_NO_CHANNELS_OR_GROUPS: "Chưa tham gia kênh hoặc nhóm nào",
    TXT_ROLE_ADMIN: "Trưởng nhóm",
    TXT_ROLE_MEMBER: "Thành viên",
    TXT_ORGANIZATION: "Tổ chức",
    TXT_ALL: "Tất cả",
    TXT_GROUP_TYPE_CHANNEL: "Kênh",
    TXT_GROUP_TYPE_GROUP: "Nhóm",
    TXT_MODE: "Chế độ",
    TXT_SETTINGS_THEME: "Giao diện",
    TXT_SETTINGS_SERVER: "Thông tin server",
    TXT_BRANCH_MODE: "Chế độ branch",
    TXT_LOGIN_MODE: "Chế độ đăng nhập",
    TXT_ADD_BRANCH: "Thêm mới Branch",
    TXT_CONFIRM_DELETE_BRANCH: "Bạn có chắc chắn muốn xóa branch?",
    TXT_NOTIFICATION_ERROR_TITLE: "Lỗi",
    TXT_NOTIFICATION_ERROR_CONTENT: "Thông tin không hợp lệ",
    TXT_CONFIRM_ACTIVE_USER: "Xác nhận kích hoạt người dùng",
    TXT_DELETE_FAIL: "Có lỗi xảy ra. Không thể xóa Branch",
    TXT_INACTIVE_ERROR: "Người dùng bạn chọn đã ở trạng thái Vô hiệu hóa. Vui lòng chọn người dùng khác.",
    TXT_ACTIVE_ERROR: "Người dùng bạn chọn đã ở trạng thái Hoạt động. Vui lòng chọn người dùng khác.",
    TXT_UPDATE_ERROR: "Có lỗi xảy ra trong quá trình thực hiện. Vui lòng thử lại.",
    TXT_INVALID_DATE: "Thông tin ngày không hợp lệ. Vui lòng chọn lại.",
    TXT_DATE_NULL: "Trường thông tin Từ ngày và Đến ngày không được để trống.",
    TXT_UPDATE_SUCCESS: "Cập nhập thông tin thành công.",
    TXT_EMAIL_WRONG: "Địa chỉ email không hợp lệ. Vui lòng kiểm tra lại.",
    TXT_UPLOAD_DUPLICATE_DATA: "Dữ liệu người dùng trùng lặp, hãy kiểm tra lại!",
    TXT_UPLOAD_MAX_USER_WRONG: "File sai format, hãy kiểm tra lại!",
    TXT_CONFIRM_CANCEL_CREATE_BRANCH: "Bạn có chắc chắn hủy quá trình tạo mới Branch?",
    TXT_OF: "trên",
    TXT_MORE_THAN: "lớn hơn",
    TXT_FAILURE_VALIDATION: "Dữ liệu gửi lên không hợp lệ. Vui lòng kiểm tra lại.",
    TXT_ADD_USER_SUCCESS: "Thêm mới người dùng thành công",
    TXT_SYSTEM_ERROR_LIST: "Danh sách lỗi hệ thống",
    TXT_USER_ACTIVITY_LIST: "Hoạt động của người dùng",
    TXT_VERIFY_SMART_OTP_CONTENT:
      "Chúng tôi đã gửi mã xác thực vào số điện thoại của bạn. Vui lòng nhập mã xác thực để tiếp tục đăng nhập.",
    TXT_RESEND_OTP: "Gửi lại OTP",
    TXT_VERIFY_OTP: "Xác thực mã OTP",
    TXT_SMART_OTP_RETRY: "Mã OTP không chính xác.\nBạn còn {{retry}} lần để nhập SMART OTP",
    TXT_SMART_OTP_BLOCK: "Chúng tôi đã khóa tài khoản vì bạn đã nhập sai OTP 3 lần.\nHãy thử lại sau 5 phút nữa",
    TXT_SMART_OTP_EXPIRED: "Mã OTP của bạn đã hết hạn",
    TXT_SMART_OTP_LIMIT_ERROR: "Mã OTP hiện tại vẫn còn hiệu lực.",
    TXT_GRANT_ADMIN_PERMISSION: "Cấp quyền quản trị viên",
    TXT_GRANT_ADMIN_PERMISSION_TITLE: "Bạn có muốn cấp quyền quản trị cho người dùng này?",
    TXT_REMOVE_ADMIN_PERMISSION: "Xóa quyền quản trị viên",
    TXT_REMOVE_ADMIN_PERMISSION_TITLE: "Bạn có muốn xóa quyền quản trị của người dùng này?",
    TXT_GENERATE_NEW_ADMIN_PASSWORD: "Tạo mật khẩu mới cho quản trị viên",
    TXT_GENERATE_NEW_ADMIN_PASSWORD_TEXT: "Khi hoàn thành tạo mật khẩu mới, tài khoản sẽ đăng xuất khỏi thiết bị",
    TXT_NEW_ADMIN_PASSWORD: "Mật khẩu mới của quản trị viên là: {{password}}",
    TXT_CONFIRM_ACTION: "Bạn có chắc chắn muốn thực hiện hành động này?",
    TXT_LOGIN_EXPIRED: "Phiên đăng nhập đã hết hạn",
    TXT_FILL_FORM: "Điền form",
    TXT_UPLOAD_FILE: "Tải file lên",
    TXT_ADD_NEW: "Thêm mới",
    TXT_USER: "Người dùng",
    TXT_UNIT: "Đơn vị",
    TXT_DEPARTMENT: "Phòng ban",
    TXT_POSITION: "Vị trí",
    TXT_STATUS: "Trạng thái",
    TXT_DOWNLOAD_SAMPLE_FILE: "Tải file mẫu",
    TXT_IMPORT_SUCCESS: "Tải file danh sách thành công",
    TXT_IMPORT_SUCCESS_MSG:
      "Người dùng trong danh sách đã được thêm vào máy chủ, hãy cung cấp mật khẩu cho người dùng để có thể bắt đầu sử dụng hệ thống.",
    TXT_IMPORT_FAILURE: "Tải file danh sách thất bại",
    TXT_IMPORT_FAILURE_MSG: "File không tải lên được do thông tin không chính xác\n Vui lòng tải lại file để chỉnh sửa",
    TXT_FILE_NOT_VALID: "File không hợp lệ",
    TXT_CHOOSE_ANOTHER_FILE_MSG: "Vui lòng chọn file khác",
    TXT_INVALID_FILE_COLUMNS_MSG:
      "File của bạn đang thiếu hoặc thừa cột so với yêu cầu. Vui lòng so sánh\nvới file mẫu để đảm bảo đầy đủ và chính xác dữ liệu trước khi tiếp tục.",
    TXT_CHOOSE_UNIT: "Chọn đơn vị",
    TXT_CHOOSE_DEPARTMENT: "Chọn phòng ban",
    TXT_CHOOSE_POSITION: "Chọn vị trí",
    TXT_TITLE_UNIT_LIST: "Danh sách đơn vị/phòng ban",
    TXT_POSITION_NAME: "Tên vị trí",
    TXT_APPLICATION_NAME: "Tên ứng dụng",
    TXT_DESCRIPTION: "Mô tả",
    TXT_ADMINISTRATOR: "Quản trị viên",
    TXT_ADD_ADMINISTRATOR: "Thêm quản trị viên",
    TXT_EDIT_ADMINISTRATOR: "Thay đổi quản trị viên",
    TXT_STT: "STT",
    TXT_FULL_NAME: "Họ và tên",
    TXT_PHONENUMBER: "Số điện thoại",
    TXT_PASSWORD: "Mật khẩu",
    TXT_DELEGATION: "Đoàn đại biểu",
    TXT_ROLE: "Vai trò",
    TXT_FOLDER_NAME: "Tên thư mục",
    TXT_EDIT_APP_INFO: "Chỉnh sửa thông tin ứng dụng",
    TXT_USERNAME: "Tên người dùng",
    TXT_ACTION: "Thao tác",
    TXT_ADD_USER: "Thêm người dùng",
    TXT_DELETE_USER: "Xóa người dùng",
    TXT_DELETE_USER_FROM_LIST: "Bạn có muốn xóa những người dùng này khỏi danh sách?",
    TXT_BIRTHDAY: "Ngày sinh",
    TXT_CHOOSE_MULTI_ROLE: "Có thể chọn nhiều hơn một vai trò",
    TXT_ROLE_DESCRIPTION: "Mô tả vai trò",
    TXT_CREATED_TIME_DATE: "Thông tin tạo",
    TXT_APP_CONFIG: "Cấu hình ứng dụng",
    TXT_APP_TITLE: "Tiêu đề ứng dụng",
    TXT_TITLE: "Tiêu đề",
    TXT_APP_FEATURES: "Tính năng ứng dụng",
    TXT_MEETING_DOCUMENTS: "Tài liệu họp",
    TXT_SEATING_POSITION: "Vị trí chỗ ngồi",
    TXT_SUPPORT: "Hỗ trợ",
    TXT_MEETING_FEEDBACK: "Góp ý cuộc họp",
    TXT_PERSONAL_NOTES: "Ghi chú cá nhân",
    TXT_SAVE_CONFIG: "Lưu cấu hình",
    TXT_ADD_ROLE: "Thêm vai trò",
    TXT_EDIT_ROLE: "Chỉnh sửa vai trò",
    TXT_UNIT_NAME: "Tên đơn vị",
    TXT_DEPARTMENT_NAME: "Tên phòng ban",
    TXT_CREATED_AT: "Thời gian tạo",
    TXT_CREATE_POSITION_TITLE: "Tạo mới vị trí",
    TXT_EDIT_POSITION_TITLE: "Sửa thông tin vị trí",
    TXT_FROM_UNIT: "Thuộc đơn vị",
    TXT_FROM_DEPARTMENT: "Thuộc phòng ban",
    TXT_CREATE_DEPARTMENT: "Thêm phòng ban",
    TXT_MEMBER_MANAGEMENT: "Quản lý thành viên",
    TXT_CREATE_CHANNEL: "Tạo kênh",
    TXT_DELETE: "Xóa",
    TXT_CREATE_UNIT: "Tạo mới đơn vị",
    TXT_EDIT_UNIT: "Chỉnh sửa đơn vị",
    TXT_ENTER_UNIT_NAME: "Nhập tên đơn vị",
    TXT_CONFIRM_DELETE_UNIT:
      "Việc xóa đơn vị đồng thời sẽ xóa toàn bộ các phòng ban trực thuộc. Bạn có chắc chắn thực hiện không?",
    TXT_CONFIRM_DELETE_DEPARTMENT:
      "Việc xóa phòng ban đồng thời sẽ xóa toàn bộ các vị trí trực thuộc. Bạn có chắc chắn thực hiện không?",
    TXT_CREATE_DEPARTMENT_TITLE: "Tạo mới phòng ban",
    TXT_EDIT_DEPARTMENT: "Chỉnh sửa phòng ban",
    TXT_ENTER_DEPARTMENT_NAME: "Nhập tên phòng ban",
    TXT_MEMBER_LIST: "Danh sách thành viên trong phòng",
    TXT_ADD_MEMBER: "Thêm thành viên",
    TXT_CREATE_POSITION_SUCCESS: "Tạo mới vị trí thành công",
    TXT_UPDATE_POSITION_SUCCESS: "Cập nhật vị trí thành công",
    TXT_DELETE_POSITION_SUCCESS: "Đã xoá vị trí.",
    TXT_UPDATE_ROLE_ACCOUNT_SUCCESS: "Cập nhật quản trị viên thành công",
    TXT_CONFIRM_DELETE_POSITION: "Bạn chắc chắn thực hiện xóa vị trí này?",
    TXT_CREATE_UNIT_SUCCESS: "Tạo mới đơn vị thành công",
    TXT_UPDATE_UNIT_SUCCESS: "Cập nhật đơn vị thành công",
    TXT_CREATE_UNIT_FAIL: "Tạo mới đơn vị thất bại",
    TXT_UNIT_DUPLICATED: "Tên đơn vị đã tồn tại",
    TXT_INVALID_UNIT_NAME: "Tên đơn vị không đúng định dạng",
    TXT_MISSING_FORM_PARAMS: "Dữ liệu truyền lên bị thiếu",
    TXT_NO_DEPARTMENTS: "Không có dữ liệu phòng ban",
    TXT_ADD_MEMBER_DIALOG: "Thêm thành viên vào phòng ban",
    TXT_CONFIRM_DELETE_MEMBER: "Bạn chắc chắn thực hiện xóa thành viên này?",
    TXT_CONFIRM_DELETE_MEMBER_TITLE: "Xoá người dùng",
    TXT_CONFIRM_DELETE_MEMBER_TEXT: "Bạn có muốn xoá người dùng này?",
    TXT_LOGOUT_BUTTON: "Đăng xuất",
    TXT_LOGOUT_TITLE: "Đăng xuất khỏi hệ thống",
    TXT_LOGOUT_TEXT: "Bạn có muốn đăng xuất khỏi hệ thống?",
    TXT_NO_UNITS: "Không có dữ liệu đơn vị",
    TXT_UNIT_CONTAIN_DEPARTMENTS: "Không thể xóa đơn vị này, đơn vị đang có phòng ban trực thuộc",
    TXT_DELETE_UNIT_SUCCESS: "Đã xóa đơn vị.",
    TXT_CREATE_DEPARTMENT_SUCCESS: "Tạo mới phòng ban thành công",
    TXT_UPDATE_DEPARTMENT_SUCCESS: "Cập nhật phòng ban thành công",
    TXT_CREATE_DEPARTMENT_FAIL: "Tạo mới phòng ban thất bại",
    TXT_DEPARTMENT_DUPLICATED: "Tên phòng ban đã tồn tại",
    TXT_INVALID_DEPARTMENT_NAME: "Tên phòng ban không đúng định dạng",
    TXT_DEPARTMENT_CONTAIN_POSITIONS: "Không thể xóa phòng ban này, phòng ban đang có vị trí trực thuộc",
    TXT_DELETE_DEPARTMENT_SUCCESS: "Đã xóa phòng ban.",
    TXT_ADD_MEMBER_SUCCESS: "Thêm thành viên thành công",
    TXT_DELETE_MEMBER_SUCCESS: "Xóa thành viên thành công",
    TXT_CREATE_CHANNEL_SUCCESS: "Tạo mới kênh thành công",
    TXT_CREATE_CHANNEL_FAIL: "Tạo mới kênh thất bại",
    TXT_CHANNEL_DUPLICATED: "Kênh đã tồn tại",
    TXT_PHONE_DUPLICATED: "Số điện thoại đã tồn tại. Lời mời tham gia đã được gửi lại.",
    TXT_DATA_WRONG_FORMAT: "Dữ liệu gửi lên không đúng định dạng",
    TXT_CREATE_ACCOUNT_SUCCESS: "Thêm mới người dùng thành công",
    TXT_CREATE_ACCOUNT_FAIL: "Thêm mới người dùng thất bại",
    TXT_INVITE_SUCCESS: "Gửi lời mời tham gia thành công",
    TXT_INVITE_FAIL: "Gửi lời mời tham gia thất bại",
    TXT_DATA_NOT_FOUND: "Không tìm thấy dữ liệu",
    TXT_TOTAL_ADMINS: "Tổng số quản trị viên",
    TXT_PHONE_INVALID: "Số điện thoại không hợp lệ",
    TXT_PASSWORD_CHANGE_SUCCESS_TITLE: "Thay đổi mật khẩu thành công",
    TXT_PASSWORD_CHANGE_SUCCESS_TEXT:
      "Bạn đã thay đổi mật khẩu thành công. Hệ thống sẽ đăng xuất các tài khoản đang đăng nhập với mật khẩu cũ. Vui lòng đăng nhập lại!",
    TXT_VIEW_DETAIL: "Xem chi tiết",
    TXT_DELETE_ADMIN: "Xóa quản trị viên",
    TXT_ADD_ADMIN: "Thêm quản trị viên",
    TXT_CONFIRM_DELETE_ADMIN_TITLE: "Xóa quản trị viên",
    TXT_CONFIRM_DELETE_ADMIN_TEXT: "Bạn có muốn xóa quản trị viên khỏi danh sách?",

    // DHD
    TXT_COPY_PASSWORD_TITLE: "Sao chép mật khẩu",
    TXT_UPDATE_PASSWORD: "Hệ thống đã cập nhật mật khẩu.",
    TXT_COPY_PASSWORD: "Xin vui lòng sao chép và gửi đến người dùng",
    TXT_COPY_ACTION: "Sao chép",
    TXT_COPY_SUCCESS: "Đã sao chép mật khẩu",
    TXT_COPY_FAILED: "Sao chép không thành công, xin vui lòng thử lại",
    TXT_CONFIG_APP: "Cấu hình ứng dụng",

    // Channel management
    TXT_TIMEOUT: "Mất kết nối đến máy chủ, xin vui lòng thử lại",
    TXT_PRIVATE_CHANNEL: "Kênh riêng tư",
    TXT_PUBLIC_CHANNEL: "Kênh công khai",
    TXT_NO_CHANNEL: "Chưa có kênh hoặc nhóm nào được tạo tại máy chủ",
    TXT_DISSOLVE_CHANNEL: "Giải tán kênh",
    TXT_DISSOLVE_CHANNEL_SUCCESS: "Đã giải tán kênh",
    TXT_DISSOLVE_CHANNEL_FAIL: "Giải tán kênh không thành công",
    TXT_GRANT_CHANNEL_ADMIN_SUCCESS: "Đã cấp quyền quản trị viên cho người dùng",
    TXT_GRANT_CHANNEL_ADMIN_FAIL: "Cấp quyền quản trị cho người dùng không thành công",
    TXT_GRANT_CHANNEL_ADMIN_BTN: "Cấp quyền quản trị",
    TXT_REVOKE_CHANNEL_ADMIN_SUCCESS: "Đã xóa quyền quản trị viên của người dùng",
    TXT_REVOKE_CHANNEL_ADMIN_FAIL: "Thu hồi quyền quản trị của người dùng không thành công",
    TXT_REVOKE_CHANNEL_ADMIN_BTN: "Xóa quyền quản trị",
    TXT_REVOKE_CHANNEL_ADMIN_DISABLED: "Kênh cần có ít nhất 1 quản trị viên",
    TXT_REMOVE_CHANNEL_MEMBER_SUCCESS: "Đã xóa người dùng khỏi kênh",
    TXT_REMOVE_CHANNEL_MEMBER_FAIL: "Xóa người dùng không thành công",
    TXT_REMOVE_CHANNEL_MEMBER_BTN: "Xóa người dùng khỏi kênh",
    TXT_REMOVE_CHANNEL_MEMBER_DISABLED_MIN: "Kênh cần có ít nhất 3 thành viên",
    TXT_ADD_CHANNEL_MEMBER_SUCCESS: "Đã thêm người dùng vào kênh",
    TXT_ADD_CHANNEL_MEMBER_FAIL: "Thêm người dùng vào kênh không thành công",
    TXT_SEARCH_CHANNEL_PLACEHOLDER: "Tìm kiếm theo tên",
    TXT_CHANNEL_SIZE_ALL: "Tất cả",
    TXT_CHANNEL_SIZE_SMALL: "Nhóm nhỏ (< 10 người)",
    TXT_CHANNEL_SIZE_MEDIUM: "Nhóm trung bình (11-50 người)",
    TXT_CHANNEL_SIZE_LARGE: "Nhóm lớn (51-100 người)",
    TXT_CHANNEL_SIZE_VERY_LARGE: "Nhóm rất lớn (> 100 người)",
    TXT_CHANNEL_SIZE_FILTER: "Quy mô nhóm",
    TXT_GROUP_TYPE_FILTER: "Loại nhóm",
    TXT_REVOKE_CHANNEL_ADMIN_TITLE: "Xóa quyền quản trị viên",
    TXT_REVOKE_CHANNEL_ADMIN_CONTENT: "Bạn có muốn xóa quyền quản trị viên của người dùng này trong kênh?",
    TXT_ADD_CHANNEL_ADMIN_TITLE: "Cấp quyền quản trị viên",
    TXT_ADD_CHANNEL_ADMIN_CONTENT: "Bạn có muốn cấp quyền quản trị viên của người dùng này trong kênh?",
    TXT_DELETE_CHANNEL_MEMBER_TITLE: "Xóa người dùng khỏi kênh",
    TXT_DELETE_CHANNEL_MEMBER_CONTENT: "Bạn có muốn xóa người dùng này khỏi kênh?",
    TXT_ADD_CHANNEL_MEMBER: "Thêm người dùng vào kênh",
    TXT_ADD_CHANNEL_MEMBER_CONTENT: "Bạn muốn thêm người dùng này vào kênh?",
    TXT_MEMBER_NOT_EXISTED: "Người dùng không tồn tại trong kênh",

    // Group management
    TXT_DISSOLVE_GROUP: "Giải tán nhóm",
    TXT_DISSOLVE_GROUP_SUCCESS: "Đã giải tán nhóm",
    TXT_DISSOLVE_GROUP_FAIL: "Giải tán nhóm không thành công",
    TXT_GRANT_GROUP_ADMIN_SUCCESS: "Đã cấp quyền trưởng nhóm cho người dùng",
    TXT_GRANT_GROUP_ADMIN_FAIL: "Cấp quyền trưởng nhóm cho người dùng không thành công",
    TXT_GRANT_GROUP_ADMIN_BTN: "Cấp quyền trưởng nhóm",
    TXT_REVOKE_GROUP_ADMIN_SUCCESS: "Đã xóa quyền trưởng nhóm của người dùng",
    TXT_REVOKE_GROUP_ADMIN_FAIL: "Thu hồi quyền trưởng nhóm của người dùng không thành công",
    TXT_REVOKE_GROUP_ADMIN_BTN: "Xóa quyền trưởng nhóm",
    TXT_REVOKE_GROUP_ADMIN_DISABLED: "Nhóm cần có ít nhất 1 trưởng nhóm",
    TXT_REMOVE_GROUP_MEMBER_SUCCESS: "Đã xóa người dùng khỏi nhóm",
    TXT_REMOVE_GROUP_MEMBER_FAIL: "Xóa người dùng không thành công",
    TXT_REMOVE_GROUP_MEMBER_BTN: "Xóa người dùng khỏi nhóm",
    TXT_REMOVE_GROUP_MEMBER_DISABLED_MIN: "Nhóm cần có ít nhất 3 thành viên",
    TXT_ADD_GROUP_MEMBER: "Thêm người dùng vào nhóm",
    TXT_ADD_GROUP_MEMBER_SUCCESS: "Đã thêm người dùng vào nhóm",
    TXT_ADD_GROUP_MEMBER_FAIL: "Thêm người dùng vào nhóm không thành công",
    TXT_ADD_GROUP_MEMBER_CONTENT: "Bạn muốn thêm người dùng này vào nhóm?",
    TXT_GROUP_NOT_EXISTED: "Người dùng không tồn tại trong nhóm",
    TXT_REVOKE_GROUP_ADMIN_TITLE: "Xóa quyền trưởng nhóm",
    TXT_REVOKE_GROUP_ADMIN_CONTENT: "Bạn có muốn xóa quyền trưởng nhóm của người dùng này trong nhóm?",
    TXT_ADD_GROUP_ADMIN_TITLE: "Cấp quyền trưởng nhóm",
    TXT_ADD_GROUP_ADMIN_CONTENT: "Bạn có muốn cấp quyền trưởng nhóm cho người dùng này trong nhóm?",
    TXT_DELETE_GROUP_MEMBER_TITLE: "Xóa người dùng khỏi nhóm",
    TXT_DELETE_GROUP_MEMBER_CONTENT: "Bạn có muốn xóa người dùng này khỏi nhóm?",

    // FORMATS
    FM_REMOVE_SINGLE_PERSON: "Bạn có muốn vô hiệu hóa {{name}} khỏi máy chủ?",
    FM_REMOVE_MULTIPLE_PEOPLE: "Bạn có muốn vô hiệu hóa {{number}} người khỏi máy chủ?",
    FM_ACTIVE_SINGLE_PERSON: "Bạn có muốn kích hoạt người dùng {{name}} không? ",
    FM_ACTIVE_MULTIPLE_PERSON: "Bạn có muốn kích hoạt {{number}} người không?",
    FM_UPLOAD_PHONE_FORMAT_WRONG: "Có {{number}} người dùng sai định dạng số điện thoại, hãy kiểm tra lại!",
    FM_COUNTDOWN_OTP: "(00:{{ time }})",

    FM_TOTAL_CHANNELS: "Tổng số: {{number}}",
    FM_TOTAL_GROUPS: "Tổng số: {{number}}",
    FM_TOTAL_MEMBERS_IN_GROUP: "Tổng số thành viên trong {{type}} {{name}}",
    FM_DISSOLVE_CHANNEL_CONTENT: "Bạn có muốn giải tán kênh {{groupName}} khỏi máy chủ?",
    FM_DISSOLVE_GROUP_CONTENT: "Bạn có muốn giải tán nhóm {{groupName}} khỏi máy chủ?",
    FM_DISSOLVE_BATCH_CONTENT: "Bạn có muốn giải tán {{number}} kênh/nhóm đã chọn khỏi máy chủ?",
    FM_DISSOLVE_BATCH_SUCCESS: "Đã giải tán thành công {{number}} kênh/nhóm",
    FM_DISSOLVE_BATCH_FAIL: "{{number}} kênh/nhóm giải tán không thành công",
    TXT_DISSOLVE_SELECTED: "Giải tán ({{number}})",

    // Statistic
    TXT_STATISTIC_USER_OVERVIEW: "Tổng quan người dùng",
    TXT_STATISTIC_MESSAGE_OVERVIEW: "Tổng quan tin nhắn",
    TXT_STATISTIC_CALL_OVERVIEW: "Tổng quan cuộc gọi",
    TXT_STATISTIC_GROUP_OVERVIEW: "Tổng quan hoạt động Kênh/Nhóm",
    TXT_STATISTIC_EXPORT: "Xuất danh sách",
    TXT_STATISTIC_DATA_UPDATED_AT: "*Dữ liệu cập nhật mới nhất vào {{time}}",
    TXT_STATISTIC_USER_COUNT_IN: "Số người sử dụng trong {{name}}",
    TXT_STATISTIC_USER_STATUS: "Trạng thái người dùng",
    TXT_STATISTIC_TOTAL_USERS: "Tổng số người dùng",
    TXT_STATISTIC_TOTAL_UNITS: "Tổng số đơn vị",
    TXT_STATISTIC_TOTAL_DEPARTMENTS: "Tổng số phòng ban",
    TXT_STATISTIC_JOINED: "Đã tham gia",
    TXT_STATISTIC_NOT_JOINED: "Chưa tham gia",
    TXT_STATISTIC_FN_DISABLED: "Vô hiệu hóa",
    TXT_STATISTIC_FN_LOGGED_IN: "Đã đăng nhập",
    TXT_STATISTIC_FN_NOT_LOGGED_IN: "Chưa đăng nhập",
    TXT_STATISTIC_FN_SUSPENDED: "Ngưng hoạt động",
    TXT_STATISTIC_TOTAL_MESSAGES_SENT: "Tổng số lượng tin nhắn đã gửi thành công:",
    TXT_STATISTIC_MESSAGES_UNIT: "tin nhắn",
    TXT_STATISTIC_NUM_MESSAGES: "Số tin nhắn",
    TXT_STATISTIC_TOTAL_CALLS_MADE: "Tổng số lượng cuộc gọi đã thực hiện:",
    TXT_STATISTIC_CALLS_UNIT: "cuộc gọi",
    TXT_STATISTIC_NUM_CALLS: "Số cuộc gọi",
    TXT_STATISTIC_CALL_STATUS_RATIO: "Tỉ lệ trạng thái cuộc gọi",
    TXT_STATISTIC_CALL_SUCCESS: "Cuộc gọi thành công",
    TXT_STATISTIC_CALL_MISSED: "Cuộc gọi nhỡ",
    TXT_STATISTIC_CALL_CANCELED: "Cuộc gọi bị huỷ",
    TXT_STATISTIC_TOTAL_CALLS: "Tổng số cuộc gọi",
    TXT_STATISTIC_USER_LIST_IN: "Danh sách người sử dụng trong {{title}}",
    TXT_STATISTIC_USER_COUNT_TITLE_IN: "Số người sử dụng trong {{title}}: ",
    TXT_STATISTIC_JOINED_USER_LIST: "Danh sách người dùng đã tham gia",
    TXT_STATISTIC_JOINED_USER_COUNT: "Số người dùng đã tham gia {{title}}: ",
    TXT_STATISTIC_NOT_JOINED_USER_LIST: "Danh sách người dùng chưa tham gia",
    TXT_STATISTIC_NOT_JOINED_USER_COUNT: "Số người dùng chưa tham gia {{title}}: ",
    TXT_STATISTIC_PEOPLE_UNIT: "người",

    // Executive Summary Cards
    TXT_CARD_TOTAL_USERS: "Tổng người dùng",
    TXT_CARD_ALL_ACCOUNTS: "Tất cả tài khoản",
    TXT_CARD_JOINED: "Đã đăng nhập",
    TXT_CARD_PENDING: "Chưa đăng nhập",
    TXT_CARD_DISABLED: "Vô hiệu hóa",
    TXT_CARD_SUSPENDED: "Ngưng hoạt động",
    TXT_CARD_ONLINE_USERS: "Đang trực tuyến",
    TXT_CARD_DETAILS: "Chi tiết →",
    TXT_CARD_CONNECTED_APP: "đang kết nối App",
    TXT_CARD_REALTIME_ONLINE: "Trực tuyến Real-time",
    TXT_CARD_TOTAL_MESSAGES: "Tổng tin nhắn",
    TXT_CARD_ALL_TIME: "Toàn thời gian",
    TXT_CARD_MESSAGES_SENT: "Tin nhắn đã gửi:",
    TXT_CARD_DIRECT_MESSAGES: "Tin cá nhân:",
    TXT_CARD_GROUP_MESSAGES: "Tin kênh/nhóm:",
    TXT_CARD_LAST_UPDATED: "Cập nhật lúc:",
    TXT_CARD_REFRESH: "Làm mới",
    TXT_CARD_AUTO_REFRESH: "Tự động làm mới",
    TXT_CARD_REFRESH_OFF: "Tắt",
    TXT_CARD_ACTIVITY_STATUS: "Trạng thái trao đổi:",
    TXT_CARD_ACTIVE: "Hoạt động",
    TXT_CARD_FILES_STORAGE: "Tệp tin & Lưu trữ",
    TXT_CARD_UPLOADED_FILES: "Tệp tải lên",
    TXT_CARD_TOTAL_FILES: "Tổng số tệp tin:",
    TXT_CARD_STORAGE_USED: "Dung lượng lưu trữ:",
    TXT_CARD_USER_ENGAGEMENT: "Mức độ hoạt động (DAU / WAU / MAU)",
    TXT_CARD_DAU_DAILY: "DAU (Hàng ngày - 24h):",
    TXT_CARD_WAU_WEEKLY: "WAU (Hàng tuần - 7 ngày):",
    TXT_CARD_MAU_MONTHLY: "MAU (Hàng tháng - 30 ngày):",
    TXT_CARD_CALLS_CONFERENCES: "Cuộc gọi & Hội nghị",
    TXT_CARD_CALLS_UNIT: "cuộc gọi",
    TXT_CARD_DIRECT_CALLS: "Gọi đơn (1-1):",
    TXT_CARD_CALL_SUCCESS: "Thành công",
    TXT_CARD_CALL_MISSED: "Nhỡ/Hủy",
    TXT_CARD_GROUP_CALLS: "Gọi nhóm:",
    TXT_CARD_GROUP_SESSIONS: "Phiên họp nhóm",
    TXT_CARD_CHANNELS_GROUPS: "Kênh & Nhóm trao đổi",
    TXT_CARD_CHANNELS_GROUPS_UNIT: "Kênh & Nhóm",
    TXT_CARD_CHANNELS_COUNT: "Số kênh:",
    TXT_CARD_GROUPS_COUNT: "Số nhóm:",
    TXT_CARD_PUBLIC: "Công khai",
    TXT_CARD_PRIVATE: "Riêng tư",
    TXT_CARD_DISCUSSION_GROUPS: "Nhóm thảo luận",


    // Statistic - SelectDateTime
    TXT_DATE_TODAY: "Hôm nay",
    TXT_DATE_LAST_7_DAYS: "7 ngày gần nhất",
    TXT_DATE_LAST_1_MONTH: "1 tháng gần nhất",
    TXT_DATE_LAST_3_MONTHS: "3 tháng gần nhất",
    TXT_DATE_BY_YEAR: "Theo năm",
    TXT_DATE_CUSTOM: "Tuỳ chỉnh",

    // Statistic - Table headers
    TXT_STATISTIC_COL_STT: "STT",
    TXT_STATISTIC_COL_TYPE: "Loại",
    TXT_STATISTIC_COL_NAME: "Tên",
    TXT_STATISTIC_COL_MEMBER_COUNT: "Số lượng thành viên",
    TXT_STATISTIC_COL_TOTAL_MESSAGES: "Tổng tin nhắn đã gửi",
    TXT_STATISTIC_COL_LAST_ACTIVE: "Hoạt động cuối cùng",

    // MediaManagement
    TXT_MEDIA_MESSAGE_LIST: "Danh sách tin nhắn",
    TXT_MEDIA_ACCOUNT_INFO: "Thông tin tài khoản",
    TXT_MEDIA_COMPOSE_NEW: "Soạn tin nhắn mới",
    TXT_MEDIA_COMPOSE: "Soạn tin nhắn",
    TXT_MEDIA_SCHEDULE_SEND: "Đặt lịch gửi tin nhắn",
    TXT_MEDIA_SCHEDULE_BTN: "Đặt lịch gửi",
    TXT_MEDIA_SEND: "Gửi",
    TXT_MEDIA_SAVE_DRAFT: "Lưu bản nháp",
    TXT_MEDIA_SAVE_DRAFT_TITLE: "Lưu bản nháp",
    TXT_MEDIA_SAVE_DRAFT_CONTENT: "Bạn có muốn lưu bản nháp không?",
    TXT_MEDIA_SAVE_DRAFT_BTN: "Lưu",
    TXT_MEDIA_EXIT: "Thoát",
    TXT_MEDIA_INPUT_PLACEHOLDER: "Nhập thông tin mô tả",
    TXT_MEDIA_MAX_CHARS_ERROR: "Nhập tối đa 500 ký tự",
    TXT_MEDIA_CONTENT_EXCEEDS: "Nội dung tin nhắn vượt quá 500 ký tự!",
    TXT_MEDIA_CONTENT_EMPTY: "Nội dung tin nhắn không được trống!",
    TXT_MEDIA_SEND_SUCCESS: "Gửi tin nhắn thành công",
    TXT_MEDIA_SCHEDULE_SUCCESS: "Đặt lịch gửi thành công",
    TXT_MEDIA_DRAFT_SAVED: "Đã lưu bản nháp tin nhắn",
    TXT_MEDIA_CANCEL_SCHEDULE: "Đã huỷ lịch gửi tin nhắn",
    TXT_MEDIA_DELETED: "Đã xoá tin nhắn",
    TXT_MEDIA_RESEND: "Gửi lại",
    TXT_MEDIA_CONTINUE: "Tiếp tục",
    TXT_MEDIA_CONFIRM_DELETE_TITLE: "Xác nhận xoá tin nhắn",
    TXT_MEDIA_CONFIRM_DELETE_CONTENT: "Bạn có muốn xóa tin nhắn này không?",
    TXT_MEDIA_CONFIRM_CANCEL_TITLE: "Xác nhận hủy gửi tin nhắn",
    TXT_MEDIA_CONFIRM_CANCEL_CONTENT: "Bạn có muốn hủy việc gửi tin nhắn này không?",
    TXT_MEDIA_CONFIRM_BTN: "Xác nhận",
    TXT_MEDIA_COL_MESSAGE: "Tin nhắn",
    TXT_MEDIA_COL_STATUS: "Trạng thái",
    TXT_MEDIA_COL_TIME: "Thời gian",
    TXT_MEDIA_COL_ACTION: "Thao tác",
    TXT_MEDIA_STATISTIC_TITLE: "Chỉ số thống kê",
    TXT_MEDIA_TOTAL_SENT: "Tổng tin nhắn đã gửi",
    TXT_MEDIA_SEND_SUCCESS_RATE: "Tỉ lệ gửi thành công",
    TXT_MEDIA_TOTAL_RECEIVED: "Tổng số người nhận tin nhắn",
    TXT_MEDIA_RECEIVE_SUCCESS_RATE: "Tỉ lệ nhận tin nhắn thành công",
    TXT_MEDIA_TOTAL_READ: "Tổng số người xem tin nhắn",
    TXT_MEDIA_READ_RATE: "Tỉ lệ xem tin nhắn",

    // BotAccountDialog
    TXT_MEDIA_ACCOUNT_NAME: "Tên tài khoản",
    TXT_MEDIA_ACCOUNT_NAME_PLACEHOLDER: "Nhập tên tài khoản",
    TXT_MEDIA_DESCRIPTION: "Thông tin mô tả",
    TXT_MEDIA_UPLOAD_AVATAR: "Tải lên ảnh",

    // System const labels
    TXT_BRANCH_STATUS_ALL: "Tất cả",
    TXT_BRANCH_STATUS_PENDING: "Chờ phê duyệt",
    TXT_BRANCH_STATUS_ACCEPTED: "Đã chấp nhận",
    TXT_BRANCH_STATUS_REJECTED: "Đã từ chối",
    TXT_BOT_STATUS_PENDING: "Đã đặt lịch gửi",
    TXT_BOT_STATUS_SUCCESS: "Đã gửi",
    TXT_BOT_STATUS_CANCELED: "Đã huỷ",
    TXT_BOT_STATUS_DRAFT: "Bản nháp",
    TXT_BOT_STATUS_FAILED: "Gửi thất bại",
    TXT_GROUP_TYPE_INBOX: "Tin nhắn riêng",

    // ConferenceManagement filters
    TXT_FILTER_ALL: "Tất cả",
    TXT_FILTER_OTHER: "Khác",

    // UserRequestManagement
    TXT_REQUEST_CONFIRM_REMOVE_REJECT: "Xác nhận gỡ trạng thái từ chối",
    TXT_REQUEST_CONFIRM_REMOVE_REJECT_CONTENT: "Bạn có muốn gỡ trạng thái từ chối của {{phone}} không?",
    TXT_REQUEST_REJECT_TITLE: "Từ chối yêu cầu tham gia",
    TXT_REQUEST_REJECT_CONTENT: "Bạn có muốn từ chối yêu cầu tham gia của {{phone}} không?",

    // UserManagement tabs
    TXT_TAB_USER_LIST: "Danh sách người dùng",
    TXT_TAB_PENDING_LIST: "Danh sách chờ phê duyệt",
    TXT_TAB_REJECTED_LIST: "Danh sách từ chối",
    TXT_TOTAL_USERS_COUNT: "Tổng số người dùng: {{count}}",

    // Settings - Theme
    TXT_THEME_CONFIG: "Cấu hình giao diện",
    TXT_THEME_LIGHT: "Giao diện sáng (Light)",
    TXT_THEME_DARK: "Giao diện tối (Dark)",
    TXT_THEME_SYSTEM: "Thiết bị",

    // ConferenceManagement
    TXT_APP_LIST: "Danh sách ứng dụng",
    TXT_ADMIN_LIST: "Danh sách quản trị viên",
    TXT_USER_LIST_LABEL: "Danh sách người dùng",
    TXT_REMOVE_MEMBER: "Xóa thành viên",
    TXT_APP_CONFIG_DESC: "*Cấu hình sẽ áp dụng cho màn hình khóa, màn hình danh sách ứng dụng, màn hình chính, màn hình thông tin sản phẩm của ứng dụng {{appName}}",
    TXT_APP_TITLE_SECTION: "Tiêu đề ứng dụng",
    TXT_TITLE_REQUIRED: "Tiêu đề (*)",
    TXT_SUBTITLE: "Tiêu đề phụ",

    // SystemTracking
    TXT_SEARCH_BUTTON: "Tìm kiếm",

    // Settings - ServerInformation
    TXT_SERVER_INFO: "Thông tin server",
    TXT_CONTENT: "Nội dung",
    TXT_PREVIEW: "Xem trước",
    TXT_QR_SERVER: "Mã QR server",
    TXT_CREATE_QR: "Tạo mới mã QR",
    TXT_SAVE_QR: "Lưu mã QR",
    TXT_IMAGE_TOO_LARGE: "Ảnh vượt quá kích thước cho phép",
    TXT_QR_EXPIRED: "Mã QR đã hết hạn sử dụng, xin vui lòng làm mới",
    TXT_QR_VALID_UNTIL: "Mã QR có thời hạn đến hết {{date}}",
  },

  deviceManagement: {
    TXT_DEVICE_MANAGEMENT_TITLE: "Quản lý thiết bị",
    TXT_DEVICE_DETAIL_TITLE: "Chi tiết thiết bị",
    TXT_DEVICE_LOADING: "Đang tải...",
    TXT_DEVICE_NOT_FOUND: "Không tìm thấy thông tin thiết bị.",
    TXT_DEVICE_SEARCH_PLACEHOLDER: "Tìm kiếm theo tên tài khoản hoặc số điện thoại",
    TXT_DEVICE_FILTER_TYPE: "Loại thiết bị",
    TXT_DEVICE_FILTER_OS: "Hệ điều hành",
    TXT_DEVICE_FILTER_VERSION: "Phiên bản",
    TXT_DEVICE_SELECT_ALL: "CHỌN TẤT CẢ THIẾT BỊ",
    TXT_DEVICE_DESELECT_ALL: "BỎ CHỌN TẤT CẢ",
    TXT_DEVICE_HEADER_ACCOUNT: "Tên tài khoản",
    TXT_DEVICE_HEADER_NAME: "Tên thiết bị",
    TXT_DEVICE_HEADER_PHONE: "SĐT",
    TXT_DEVICE_HEADER_ROLE: "Vai trò",
    TXT_DEVICE_HEADER_TYPE: "Loại",
    TXT_DEVICE_HEADER_OS: "HĐH",
    TXT_DEVICE_HEADER_STATUS: "Trạng thái",
    TXT_DEVICE_HEADER_FIRST_LOGIN: "Đăng nhập đầu",
    TXT_DEVICE_HEADER_VERSION: "Phiên bản",
    TXT_DEVICE_HEADER_LAST_ACTIVITY: "Hoạt động cuối",
    TXT_DEVICE_HEADER_ACTIONS: "Thao tác",
    TXT_DEVICE_ACTION_LOGOUT: "ĐĂNG XUẤT",
    TXT_DEVICE_ACTION_BLOCK: "CHẶN",
    TXT_DEVICE_ACTION_UNBLOCK: "BỎ CHẶN",
    TXT_DEVICE_BLOCK_SUCCESS: "Đã chặn thiết bị thành công",
    TXT_DEVICE_BLOCK_FAIL: "Chặn thiết bị thất bại",
    TXT_DEVICE_BLOCK_ERROR: "Lỗi khi chặn thiết bị",
    TXT_DEVICE_UNBLOCK_SUCCESS: "Đã bỏ chặn thiết bị thành công",
    TXT_DEVICE_UNBLOCK_FAIL: "Bỏ chặn thiết bị thất bại",
    TXT_DEVICE_UNBLOCK_ERROR: "Lỗi khi bỏ chặn thiết bị",
    TXT_DEVICE_LOGOUT_SUCCESS: "Đã đăng xuất thiết bị thành công",
    TXT_DEVICE_LOGOUT_FAIL: "Đăng xuất thiết bị thất bại",
    TXT_DEVICE_LOGOUT_ERROR: "Lỗi khi đăng xuất thiết bị",
    TXT_DEVICE_FETCH_ERROR: "Lỗi khi tải danh sách thiết bị",
    TXT_DEVICE_CONFIRM_LOGOUT_SINGLE: "Bạn có chắc chắn muốn đăng xuất thiết bị này?",
    TXT_DEVICE_CONFIRM_BLOCK_SINGLE: "Bạn có chắc chắn muốn chặn thiết bị này?",
    TXT_DEVICE_CONFIRM_UNBLOCK_SINGLE: "Bạn có chắc chắn muốn bỏ chặn thiết bị này?",
    TXT_DEVICE_DETAIL_INFO: "THÔNG TIN THIẾT BỊ",
    TXT_DEVICE_DETAIL_ACCOUNT_INFO: "THÔNG TIN TÀI KHOẢN",
    TXT_DEVICE_DETAIL_ACTIVITY: "HOẠT ĐỘNG",
    TXT_DEVICE_DETAIL_LAST_ACTIVITY: "Hoạt động gần nhất",
    TXT_DEVICE_DETAIL_FIRST_LOGIN: "Đăng nhập lần đầu",
    TXT_DEVICE_DETAIL_ACTIVE_NOW: "Đang hoạt động",
    TXT_DEVICE_LABEL_ACCOUNT_NAME: "Tên tài khoản",
    TXT_DEVICE_LABEL_EMAIL: "Email",
    TXT_DEVICE_LABEL_PHONE: "Số điện thoại",
    TXT_DEVICE_LABEL_ADDRESS: "Địa chỉ",
    TXT_DEVICE_LABEL_UNIT: "Đơn vị",
    TXT_DEVICE_LABEL_DEPARTMENT: "Phòng ban",
    TXT_DEVICE_LABEL_DEVICE_NAME: "Tên thiết bị",
    TXT_DEVICE_LABEL_OS: "Hệ điều hành",
    TXT_DEVICE_LABEL_OS_VERSION: "Phiên bản hệ điều hành",
    TXT_DEVICE_LABEL_APP_VERSION: "Phiên bản Trios",
    TXT_DEVICE_STATUS_BLOCKED: "Bị chặn",
    TXT_DEVICE_STATUS_ACTIVE: "Hoạt động",
    TXT_DEVICE_STATUS_ABSENT: "Vắng mặt",
    TXT_DEVICE_STATUS_LOGGED_OUT: "Đã đăng xuất",
    TXT_DEVICE_ROLE_MASTER: "Chủ",
    TXT_DEVICE_ROLE_SECONDARY: "Phụ",
    TXT_DEVICE_TAB_ACTIVE_LIST: "DANH SÁCH THIẾT BỊ",
    TXT_DEVICE_TAB_BLOCKED_LIST: "DANH SÁCH BỊ CHẶN",
    TXT_DEVICE_TIME_JUST_NOW: "Vừa xong",
    FM_DEVICE_SELECTED_COUNT: "Đã chọn {{count}} thiết bị",
    FM_DEVICE_CONFIRM_LOGOUT_BULK: "Bạn có chắc chắn muốn đăng xuất {{count}} thiết bị?",
    FM_DEVICE_CONFIRM_BLOCK_BULK: "Bạn có chắc chắn muốn chặn {{count}} thiết bị?",
    FM_DEVICE_CONFIRM_UNBLOCK_BULK: "Bạn có chắc chắn muốn bỏ chặn {{count}} thiết bị?",
    FM_DEVICE_TIME_MINUTES_AGO: "{{count}} phút trước",
    FM_DEVICE_TIME_HOURS_AGO: "{{count}} giờ trước",
    FM_DEVICE_TIME_DAYS_AGO: "{{count}} ngày trước",
  },
};

export default vi;
